import referralService from './referralService';
import { captureAcquisitionSession } from './acquisitionSession';

const UTM_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

function getLocationSnapshot(locationOverride) {
  if (locationOverride) {
    return locationOverride;
  }

  if (typeof window !== 'undefined' && window.location) {
    return window.location;
  }

  return {
    pathname: '/',
    search: '',
  };
}

function normalizeString(value) {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function getStoredReferralCode() {
  return normalizeString(referralService.getStoredReferralCode());
}

export function buildAcquisitionMetadata(options = {}) {
  const location = getLocationSnapshot(options.location);
  const searchParams = new URLSearchParams(location.search || '');
  const sessionSnapshot =
    options.sessionSnapshot ||
    captureAcquisitionSession({
      location,
      storage: options.sessionStorage,
      capturedAt: options.capturedAt,
      persistReferral: options.persistReferral,
    });
  const referralCode =
    normalizeString(options.referralCode) ||
    normalizeString(searchParams.get('ref')) ||
    normalizeString(sessionSnapshot?.ref) ||
    getStoredReferralCode() ||
    null;
  const utmValues = Object.fromEntries(
    UTM_FIELDS.map((key) => [
      key,
      normalizeString(searchParams.get(key)) ||
        normalizeString(sessionSnapshot?.[key]) ||
        null,
    ])
  );
  const hasCampaignParams = Object.values(utmValues).some(Boolean);

  return {
    channel: referralCode
      ? 'referral'
      : utmValues.utm_medium || (hasCampaignParams ? 'campaign' : 'direct'),
    ...(referralCode ? { referral_code: referralCode } : {}),
    ...Object.fromEntries(
      Object.entries(utmValues).filter(([, value]) => Boolean(value))
    ),
    landing_path:
      normalizeString(sessionSnapshot?.landing_path) ||
      `${location.pathname || '/'}${location.search || ''}`,
    captured_at:
      options.capturedAt ||
      normalizeString(sessionSnapshot?.captured_at) ||
      new Date().toISOString(),
  };
}

export function appendAcquisitionMetadata(payload, options = {}) {
  return {
    ...payload,
    metadata: {
      ...(payload.metadata || {}),
      ...buildAcquisitionMetadata(options),
    },
  };
}
